/**
 * trésjolie — Doppelregler fuer den Preisfilter
 *
 * Zwei uebereinanderliegende Schieber, dazwischen die farbige Strecke.
 * Die vorhandenen Zahlenfelder bleiben fuehrend: Was der Regler setzt,
 * schreibt er dorthin und loest die Ereignisse aus, auf die Dawn hoert.
 */
class TjPreisregler extends HTMLElement {
  connectedCallback() {
    this.von = this.querySelector('[data-rolle="von"]');
    this.bis = this.querySelector('[data-rolle="bis"]');
    this.strecke = this.querySelector('[data-strecke]');
    if (!this.von || !this.bis) return;

    // Die Zahlenfelder stehen als Geschwister hinter dem Regler
    const eltern = this.parentElement;
    this.feldVon = eltern.querySelector('input[id$="-GTE"]');
    this.feldBis = eltern.querySelector('input[id$="-LTE"]');

    this.von.addEventListener('input', () => this.vomRegler('von'));
    this.bis.addEventListener('input', () => this.vomRegler('bis'));

    // Nach dem Loslassen filtern, nicht bei jedem Pixel
    for (const s of [this.von, this.bis]) {
      s.addEventListener('change', () => this.melden());
    }

    this.feldVon?.addEventListener('input', () => this.vomFeld());
    this.feldBis?.addEventListener('input', () => this.vomFeld());

    this.vomFeld();
  }

  zahl(text) {
    const n = parseFloat(String(text ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  }

  /** Regler bewegt: Werte ordnen und in die Felder schreiben */
  vomRegler(rolle) {
    let a = Number(this.von.value);
    let b = Number(this.bis.value);

    // Die Schieber duerfen einander nicht ueberholen
    if (a > b) {
      if (rolle === 'von') a = b;
      else b = a;
      this.von.value = String(a);
      this.bis.value = String(b);
    }

    const max = Number(this.dataset.max);
    if (this.feldVon) this.feldVon.value = a > 0 ? String(a) : '';
    if (this.feldBis) this.feldBis.value = b < max ? String(b) : '';

    this.streckeZeichnen();
  }

  /** Feld getippt: Regler nachziehen */
  vomFeld() {
    const max = Number(this.dataset.max);
    const a = this.zahl(this.feldVon?.value) ?? 0;
    const b = this.zahl(this.feldBis?.value) ?? max;
    this.von.value = String(Math.min(Math.max(a, 0), max));
    this.bis.value = String(Math.min(Math.max(b, 0), max));
    this.streckeZeichnen();
  }

  streckeZeichnen() {
    const max = Number(this.dataset.max) || 1;
    const a = (Number(this.von.value) / max) * 100;
    const b = (Number(this.bis.value) / max) * 100;
    this.strecke.style.left = `${a}%`;
    this.strecke.style.width = `${Math.max(0, b - a)}%`;
  }

  /** Dawn hoert auf Aenderungen an den Feldern */
  melden() {
    for (const feld of [this.feldVon, this.feldBis]) {
      feld?.dispatchEvent(new Event('input', { bubbles: true }));
      feld?.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

if (!customElements.get('tj-preisregler')) {
  customElements.define('tj-preisregler', TjPreisregler);
}
